import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

const axiosClient = axios.create()

axiosClient.interceptors.request.use(async (config) => {
  const isExpired = await store.dispatch('auth/isMckidTokenExpired')

  if (isExpired) {
    const refresh = await axios.post(`${servers[store.state.auth.server].platform}/api/v1/auth/refresh`, { 'refresh_token': store.state.auth.mckidRefreshToken })
    store.dispatch('auth/refreshedToken', refresh.data)
  }

  config.headers.Authorization = store.state.auth.mckidToken
  return config
}, (error) => {
  return error
})

export const getBlueprintTasks = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks${queryParams}`)

  return response.data
}

export const getTaskEvidence = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/evidence${queryParams}`)

  return response.data
}

export const getBlueprintQMatrices = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices${queryParams}`)

  return response.data
}

export const postQMatrix = async (data) => {
  const params = new URLSearchParams()
  params.append('name', data.name)
  params.append('task_id', data.taskId)
  params.append('is_authoritative', data.isAuthoritative)

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices`, params)

  return response.data
}

export const putQMatrix = async (data) => {
  const params = new URLSearchParams()

  params.append('id', data.id)
  params.append('name', data.name)
  params.append('task_id', data.taskId)
  params.append('is_authoritative', data.isAuthoritative)

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices`, params)

  return response.data
}

export const postBlueprintTask = async (data) => {
  const params = new URLSearchParams()
  params.append('name', data.name)
  params.append('description', data.description)

  if ('q_matrix_id' in data) {
    params.append('q_matrix_id', data.q_matrix_id)
  }

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks`, params)

  return response.data
}

export const putBlueprintTask = async (data) => {
  const params = new URLSearchParams()
  params.append('id', data.id)
  params.append('name', data.name)
  params.append('description', data.description)
  params.append('q_matrix_id', data.q_matrix_id)

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks`, params)
  return response.data
}

export const postTaskEvidence = async (data) => {
  const params = new URLSearchParams()
  params.append('name', data.name)
  params.append('description', data.description)
  params.append('task_id', data.task_id)

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/evidence`, params)

  return response.data
}

export const putTaskEvidence = async (data) => {
  const params = new URLSearchParams()
  params.append('id', data.id)
  params.append('name', data.name)
  params.append('description', data.description)
  params.append('task_id', data.task_id)

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/evidence`, params)
  return response.data
}

export const getTaskItems = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/items${queryParams}`)

  return response.data
}

export const postTaskItem = async (data) => {
  const params = new URLSearchParams()

  if ('code' in data) {
    params.append('code', data.code)
  }

  if ('name' in data) {
    params.append('name', data.name)
  }
  if ('range' in data) {
    params.append('range', data.range)
  }
  if ('version' in data) {
    params.append('version', data.version)
  }
  if ('goal' in data) {
    params.append('goal', data.goal)
  }
  if ('behavior' in data) {
    params.append('behavior', data.behavior)
  }

  if ('definition' in data) {
    params.append('definition', data.definition)
  }

  if ('task_id' in data) {
    params.append('task_id', data.task_id)
  }

  if ('task_item_evidence_mapping' in data) {
    params.append('task_item_evidence_mapping', JSON.stringify(data.task_item_evidence_mapping))
  }

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/items`, params)

  return response.data
}

export const putTaskItem = async (data) => {
  const params = new URLSearchParams()

  params.append('id', data.id)

  if ('code' in data) {
    params.append('code', data.code)
  }
  if ('name' in data) {
    params.append('name', data.name)
  }
  if ('range' in data) {
    params.append('range', data.range)
  }
  if ('version' in data) {
    params.append('version', data.version)
  }
  if ('goal' in data) {
    params.append('goal', data.goal)
  }
  if ('behavior' in data) {
    params.append('behavior', data.behavior)
  }

  if ('definition' in data) {
    params.append('definition', data.definition)
  }

  if ('task_id' in data) {
    params.append('task_id', data.task_id)
  }

  if ('task_item_evidence_mapping' in data) {
    params.append('task_item_evidence_mapping', JSON.stringify(data.task_item_evidence_mapping))
  }

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/items`, params)

  return response.data
}

export const getConstructs = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs${queryParams}`)

  return response.data
}

export const getConstructTypes = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs/types${queryParams}`)
  return response.data
}

export const postConstruct = async (data) => {
  const params = new URLSearchParams()

  params.append('name', data.name)
  params.append('construct_type_id', data.construct_type_id)

  if ('definition' in data) {
    params.append('definition', data.definition)
  }

  if ('is_observable' in data) {
    params.append('is_observable', data.is_observable)
  }

  if ('parent_construct_id' in data) {
    params.append('parent_construct_id', data.parent_construct_id)
  }

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs`, params)

  return response.data
}

export const putConstruct = async (data) => {
  const params = new URLSearchParams()

  params.append('id', data.id)

  if ('name' in data) {
    params.append('name', data.name)
  }

  if ('construct_type_id' in data) {
    params.append('construct_type_id', data.construct_type_id)
  }

  if ('definition' in data) {
    params.append('definition', data.definition)
  }

  if ('is_observable' in data) {
    params.append('is_observable', data.is_observable)
  }

  if ('parent_construct_id' in data) {
    params.append('parent_construct_id', data.parent_construct_id)
  }

  if ('construct_task_item_mapping' in data) {
    params.append('construct_task_item_mapping', JSON.stringify(data.construct_task_item_mapping))
  }

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs`, params)

  return response.data
}

export const getModels = async (data) => {
  let encodedQueryParams = encodeURIComponent(`${data['values']}`)

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models?${data['type']}=${encodedQueryParams}`)
  return response.data
}

export const postModel = async (data) => {
  const params = new URLSearchParams()

  params.append('name', data.name)
  params.append('description', data.description)

  if (data.psychometric_model_task_mapping) {
    params.append('psychometric_model_task_mapping', JSON.stringify(data.psychometric_model_task_mapping))
  }

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models`, params)

  return response.data
}

export const putModel = async (data) => {
  const params = new URLSearchParams()

  params.append('id', data.id)
  params.append('name', data.name)
  params.append('description', data.description)

  if (data.psychometric_model_task_mapping) {
    params.append('psychometric_model_task_mapping', JSON.stringify(data.psychometric_model_task_mapping))
  }

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models`, params)

  return response.data
}

export const postModelItemMappings = async (data) => {
  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models/task-item-mappings`, data)

  return response.data
}

export const postQMatrixItemMappings = async (data) => {
  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices/task-item-mappings`, data)

  return response.data
}

export const getAssociationTypes = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axiosClient.get(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/items/association-types${queryParams}`)

  return response.data
}

export const postConstructTaskItemMapping = async (payload) => {
  const params = new URLSearchParams()

  params.append('task_item_id', payload.task_item_id)
  params.append('construct_id', payload.construct_id)
  params.append('item_association_type_id', payload.item_association_type_id)

  const response = await axiosClient.post(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs/task-item-mappings`, params)

  return response.data
}

export const putConstructTaskItemMapping = async (payload) => {
  const params = new URLSearchParams()

  params.append('id', payload.id)
  params.append('task_item_id', payload.task_item_id)
  params.append('construct_id', payload.construct_id)
  params.append('item_association_type_id', payload.item_association_type_id)

  const response = await axiosClient.put(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs/task-item-mappings`, params)

  return response.data
}

export const deleteConstructTaskItemMapping = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs/task-item-mappings?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteConstruct = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/constructs?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteModelItemMappings = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models/task-item-mappings?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deletePsychometricModel = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/psychometric-models?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteQMatrixItemMapping = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices/task-item-mappings?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteQMatrices = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/q-matrices?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteTaskEvidence = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/evidence?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteTaskItems = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks/items?ids=${payload.join(',')}`)
    return response.data
  }
}

export const deleteTask = async (payload) => {
  if (payload.length > 0) {
    const response = await axiosClient.delete(`${servers[store.state.auth.server].blueprint_content_manager}/api/tasks?ids=${payload.join(',')}`)
    return response.data
  }
}
